import { Box, TextField } from "@mui/material";

type Props = {
  latitude: string;
  longitude: string;
};

export function ReadOnlyCoordinates({ latitude, longitude }: Props) {
  return (
    <Box
      sx={{
        display: "flex",
        direction: "row",
      }}
    >
      <TextField
        value={latitude || "-"}
        variant="standard"
        id="latitude"
        label="Latitude"
        size="small"
        sx={{
          paddingRight: 2,
        }}
        InputProps={{
          readOnly: true,
          disableUnderline: true,
        }}
      />
      <TextField
        value={longitude || "-"}
        variant="standard"
        id="longitude"
        label="Longitude"
        size="small"
        InputProps={{
          readOnly: true,
          disableUnderline: true,
        }}
      />
    </Box>
  );
}
